const ScopeType = {
    COMPANY: 20,
    PARTNER: 40,
    WHOLESALER: 60,
    GLOBAL: 80,
};

export const Scope = (scope) => {
    switch (scope) {
        case ScopeType.PARTNER:
            return 'Partner';
        case ScopeType.WHOLESALER:
            return 'Wholesaler';
        case ScopeType.GLOBAL:
            return 'Global';
        default:
            return 'company';
    }
};

export default ScopeType;
